import $ from "./jq";
(function(){
    let $links = $(".j-site-link");
    $links.removeClass("cur");
    let index = 0; // 首页
    let href = window.location.href;
    let ids = $.getHrefParam("ids");
    if(ids == 15 || ids == 19 || ids == 23 || ids == 27){ // 公告
        index = 1;
    }
    if(ids == 17 || ids == 21 || ids == 25 || ids == 29){ // 攻略
        index = 2;
    }
    $links.eq(index).addClass("cur")
    const userAgent = window.navigator.userAgent;
    const ua = userAgent.toLowerCase();
    const platform = {
          isAndroid: function() {
              return ua.indexOf("android") > -1;
          },
          isIOS: function() {
              // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
              return ua.indexOf("iphone") > -1;
          },
          isWinPhone: function() {
              return !!navigator.userAgent.match(/Windows Phone/i);
          },
          isIpad : function(){
              return ua.indexOf("ipad") > -1;
          },
          isPhone: function() {
              return this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad();
          }
    }
    window.isPhone = platform.isPhone();
        // 切换语言
    if (window.isPhone) {
        $('.j-select-language').on('click', function (e) {
            e.stopPropagation()
            $(this).addClass('active')
            $('.language-pop').fadeIn()
        })
        $('body').on('click', () => {
            $('.language-pop').fadeOut()
        })
        $('.j-language').on('click', '.item', function(e) {
            const language = $(this).attr('data-lang')
            window.location.href = 'https://global.37games.com/dbcv/mobile?language=' + language
        })
        } else {
        $(".j-returnBtn").on("click",function(){
            window.history.back()
        })
        $('.j-select-language').hover(function () {
            $(this).addClass('active')
            $('.language-pop').fadeIn()
        })
        $('.j-language').mouseleave(() => {
            $('.language-pop').fadeOut()
            $('.j-select-language').removeClass('active')
        })
        $('.j-language').on('click', '.item', function(e) {
            const language = $(this).attr('data-lang')
            window.location.href = 'https://global.37games.com/dbcv?language=' + language
        })
        }
})()